<h2>Products</h2>

<div class="product" *ngFor="let product of products; index as productId">
  <a class="prod-image" [title]="product.name" [routerLink]="['/products', productId]">
	<img  src="{{ product.images[0] }}"/>
  </a>
  <div class="prod-desc">
  	<h3 class="ptitle">
    	<a [title]="product.name + ' details'" [routerLink]="['/products', productId]">
      		{{ product.name }}
      
    	</a>
  	</h3>

  	<p *ngIf="product.description">
    	{{ product.description}}
  	</p>

  	<button [routerLink]="['/products',productId]">
    	view
  	</button>
  </div>
</div>
<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
-->
